import {defineStore} from 'pinia'

export const usePermissionsStore = defineStore('permissions', {
    state: () => ({
        permissions: [] as string[],
    }),
    actions: {
        async load() {
            this.permissions = await useApi().getAuthPermissions()
        },

        handleCentrifugeNotification(message: {
            type: string,
            operation: string,
            role: string,
            permission: string,
        }) {

            // Якщо прийшло щось інше, не обробляємо
            if (!message || message.type !== 'role_permissions') {
                return
            }

            const {operation, role, permission} = message
            if (!operation || !role || !permission) {
                return
            }

            switch (operation.toLowerCase()) {
                case 'insert':
                    if (!this.permissions.includes(permission)) {
                        this.permissions.push(permission)
                    }
                    break

                case 'update':
                    if (!this.permissions.includes(permission)) {
                        this.permissions.push(permission)
                    }
                    break

                case 'delete':
                    this.permissions = this.permissions.filter(p => p !== permission)
                    break
            }
        }
    },
})
